import { gql } from '@apollo/client';

export const SOFT_SKILL_PAYLOAD = gql`
    fragment SoftSkillFragment on SoftSkill {
        _id
        name
    }
`;

export const getSoftSkillsQuery = gql`
    query getSoftSkills {
        softSkills: getSoftSkills {
            ...SoftSkillFragment
        }
    }
    ${SOFT_SKILL_PAYLOAD}
`;

export const ADD_SOFT_SKILL_PRO = gql`
  mutation addSoftSkillPro($name: String!, $order: Int) {
    data: addSoftSkillPro(name: $name, order: $order) {
      _id
      name
      category
      status
      order
    }
  }
`;

export const DELETE_SOFT_SKILL_PRO = gql`
  mutation deleteSoftSkillPro($id: ID!) {
    deleteSoftSkillPro(id: $id)
  }
`;
